export const cardName=card=>`${card.rank} of ${{S:'spades',H:'hearts',D:'diamonds',C:'clubs'}[card.suit]}`;
export function pause(ms,signal){return new Promise((resolve,reject)=>{
 let timer;const abort=()=>{clearTimeout(timer);signal?.removeEventListener('abort',abort);reject(Object.assign(new Error('Cancelled'),{name:'AbortError'}));};
 if(signal?.aborted){abort();return;}signal?.addEventListener('abort',abort,{once:true});timer=setTimeout(()=>{signal?.removeEventListener('abort',abort);resolve();},ms);
});}
// Swap only while the opaque P back is visible, then reveal the server-confirmed face.
export function createCardPresenter(node,paint,{wait=pause}={}){
 let generation=0;
 const show=card=>{generation++;paint(card);node.classList.add('face-up');node.classList.remove('is-flipping');};
 async function flip(card,{reduced=false,signal}={}){
  const gen=++generation,check=()=>{if(signal?.aborted||generation!==gen)throw Object.assign(new Error('Cancelled'),{name:'AbortError'});};
  check();node.classList.remove('is-hit','is-miss');
  if(reduced){await wait(40,signal);check();paint(card);node.classList.add('face-up');return;}
  node.classList.add('is-flipping');node.classList.remove('face-up');node.setAttribute('aria-label','Turning card');
  await wait(260,signal);check();paint(card);node.classList.add('face-up');
  await wait(300,signal);check();node.classList.remove('is-flipping');
 }
 return{show,flip,cancel:()=>{generation++;node.classList.remove('is-flipping');}};
}
